import { QRCodeCanvas } from 'qrcode.react';
import DraggableModal from '../../../../components/DraggableModal';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import qrBackground from '../../../../assets/images/qr_print_cut.png'
import Button from "../../components/Button";

const LoginQrCodeModal = ({ showLoginQrModal, setShowLoginQrModal, students, mainClass }) => {
  const contentRef = useRef(null);

  const printBtn = () => {
    if(students && students.length>0){
      handlePrint();
    }else{
      alert("학생 데이터가 없습니다.");
    }
  }
  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
  });

  // 학생 데이터를 1 페이지당 9명씩 나누기
  const chunkedStudents = students
      ? Array.from({ length: Math.ceil(students.length / 9) }, (_, i) =>
          students.slice(i * 9, i * 9 + 9)
      )
      : [];

  return (
    <DraggableModal show={showLoginQrModal} setShow={setShowLoginQrModal} title={'로그인QR 인쇄 목록'} titleStyle={`text-[#50555F] text-[28px] font-[700] mt-[19px] mb-[12px]`} headerHeight={65}>
      <div className={'w-[210mm] h-[320mm]'}>
        <div className="flex justify-center mt-8">
          <Button label="인쇄하기" onClick={printBtn}/>
        </div>
        <div
            className={`mt-[0px] ${!students?.length ? 'empty-content' : 'print'}`}
            ref={contentRef}
        >
          {chunkedStudents.map((studentPage, pageIndex) => (
              <div key={pageIndex} className="relative">
                <img
                  src={qrBackground}
                  alt="qrBackground"
                  className="print-background absolute flex-col items-center w-[210mm] h-[297mm]"
                />
                {studentPage && studentPage.length > 0 ? (
                    <div className={'grid grid-flow-row auto-rows-max gap-4 grid-cols-[repeat(auto-fill,minmax(200px,1fr))] place-items-start pl-[40px]  w-[210mm] h-[297mm] border-b-2'}>
                      {studentPage.map((value, index) => (
                          <div
                              key={index}
                              className={'w-[196px]  px-[14px] py-[20px] mb-[10px] mt-[30px]'}
                          >
                            <div className={'flex justify-center font-[pd-sb] text-[20px]'}>AI 아크수학</div>
                            <div
                                className={
                                  'justify-center px-[16px] mt-[20px] font-[pd-sb] text-[18px] truncate text-center'
                                }
                            >
                              {mainClass?.name}
                            </div>
                            <div className={'flex justify-center'}>
                              <div>
                                <div>번호&nbsp;&nbsp;&nbsp;{value.number}</div>
                                <div className={'truncate w-[140px]'}>이름&nbsp;&nbsp;&nbsp;{value.name}</div>
                              </div>
                            </div>
                            <div className={'flex justify-center'}>
                              <QRCodeCanvas
                                  value={`${process.env.REACT_APP_SCHOOL_WEB_URL}/qrcode?type=login&studentId=${value.studentId}`}
                                  size={128}
                                  bgColor="#ffffff"
                                  fgColor="#000000"
                                  className={'mt-[20px]'}
                              />
                            </div>
                          </div>
                      ))}
                    </div>
                ) : (
                    <div className="flex justify-center items-center my-[50px] text-center">
                      <p>학생 데이터가 없습니다.</p>
                    </div>
                )}
              </div>
        ))}
        </div>
      </div>
    </DraggableModal>
  );
};

export default LoginQrCodeModal;
